const CAPY_COLOR_MODE_KEY = 'capy-color-mode';
const DARK_MODE = 'dark';
const LIGHT_MODE = 'light';

function currentMode() {
  return document.documentElement.dataset.capyTheme === DARK_MODE ? DARK_MODE : LIGHT_MODE;
}

function syncBrowserChrome(mode) {
  const header = document.querySelector('header-component');
  const color = mode === DARK_MODE ? header?.dataset.themeColorDark : header?.dataset.themeColorLight;

  if (!color) return;

  header.dataset.themeColor = color;
  document.querySelectorAll('meta[name="theme-color"]').forEach((meta) => {
    meta.setAttribute('content', color);
  });
}

function syncToggle(toggle, mode) {
  const isDark = mode === DARK_MODE;
  toggle.setAttribute('aria-pressed', String(isDark));
  toggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
  toggle.dataset.capyThemeTooltip = isDark ? toggle.dataset.capyLightTooltip : toggle.dataset.capyDarkTooltip;
}

function syncThemeControls() {
  const mode = currentMode();
  document.querySelectorAll('[data-capy-theme-toggle]').forEach((toggle) => syncToggle(toggle, mode));
  syncBrowserChrome(mode);
  window.CapyDarkMode?.syncThemeMedia();
  document.documentElement.dataset.capyThemeReady = '';
}

function applyMode(mode) {
  document.documentElement.dataset.capyTheme = mode;

  try {
    localStorage.setItem(CAPY_COLOR_MODE_KEY, mode);
  } catch (error) {
    // Storage may be unavailable in privacy modes; the current page still switches.
  }

  syncThemeControls();
  document.dispatchEvent(new CustomEvent('capy:color-mode-change', { detail: { mode } }));
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const toggle = event.target.closest('[data-capy-theme-toggle]');
  if (!toggle) return;

  applyMode(currentMode() === DARK_MODE ? LIGHT_MODE : DARK_MODE);
});

document.addEventListener('shopify:section:load', syncThemeControls);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncThemeControls, { once: true });
} else {
  syncThemeControls();
}
